
import { useState } from 'react';

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '¿Necesito experiencia previa en marketing digital?',
      answer:
        'No, este curso está diseñado para principiantes. Comenzamos desde cero y te guiamos paso a paso hasta que domines las estrategias de tráfico y ventas digitales.',
    },
    {
      question: '¿Cuánto tiempo necesito dedicar al día?',
      answer:
        'Con solo 1-2 horas al día puedes implementar las estrategias. El curso está diseñado para personas ocupadas que quieren resultados sin sacrificar todo su tiempo.',
    },
    {
      question: '¿Qué incluye el acceso de por vida?',
      answer:
        'Incluye acceso ilimitado a todos los cursos actuales y futuros, actualizaciones constantes, comunidad privada en Skool, clases en vivo mensuales y soporte 24/7.',
    },
    {
      question: '¿Cuándo puedo empezar a ver resultados?',
      answer:
        'Muchos de nuestros estudiantes comienzan a ver sus primeras ventas en las primeras semanas. Los resultados dependen de tu dedicación y aplicación de las estrategias.',
    },
    {
      question: '¿El contenido se actualiza?',
      answer:
        'Sí, constantemente actualizamos el contenido con las últimas estrategias y tendencias del mercado. Como miembro de por vida, tendrás acceso a todas las actualizaciones sin costo adicional.',
    },
    {
      question: '¿Qué tipo de soporte recibiré?',
      answer:
        'Tendrás acceso a soporte 24/7 a través de nuestra comunidad privada, donde podrás hacer preguntas, compartir tus avances y recibir retroalimentación de mentores y otros estudiantes.',
    },
    {
      question: '¿Funciona en cualquier país?',
      answer:
        'Sí, las estrategias que enseñamos funcionan en cualquier país. El marketing digital no tiene fronteras y puedes aplicar todo lo que aprendes desde donde estés.',
    },
  ];

  return (
    <section className="relative py-12 sm:py-16 lg:py-24 xl:py-32 overflow-hidden bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100">
      <div className="absolute top-0 right-0 w-48 h-48 sm:w-64 sm:h-64 lg:w-96 lg:h-96 bg-gradient-to-br from-emerald-300/20 to-cyan-300/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 sm:w-64 sm:h-64 lg:w-96 lg:h-96 bg-gradient-to-br from-teal-300/20 to-emerald-300/20 rounded-full blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-emerald-100 text-emerald-700 font-semibold mb-3 sm:mb-4 text-xs sm:text-sm">
            <i className="ri-question-line text-base sm:text-lg"></i>
            <span>Preguntas Frecuentes</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-gray-900 mb-3 sm:mb-4">
            ¿Tienes dudas? <span className="bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">Te ayudamos</span>
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            Resolvemos las preguntas más comunes sobre el curso y la comunidad
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg sm:rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-6 py-4 sm:py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 text-sm sm:text-base lg:text-lg pr-3 sm:pr-4">{faq.question}</span>
                <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-white text-lg sm:text-xl transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-4 sm:px-6 pb-4 sm:pb-5 text-gray-600 text-xs sm:text-sm lg:text-base leading-relaxed border-t border-gray-100 pt-3 sm:pt-4">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 p-5 sm:p-6 lg:p-8 rounded-2xl sm:rounded-3xl bg-gradient-to-r from-emerald-50 to-cyan-50 border-2 border-emerald-200">
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 text-center mb-6 sm:mb-8">Garantía y Soporte Permanente</h3>
          <div className="grid sm:grid-cols-3 gap-4 sm:gap-6">
            <div className="flex flex-col items-center text-center p-4 sm:p-5 lg:p-6 bg-white rounded-xl sm:rounded-2xl shadow-sm">
              <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-shield-check-line text-white text-lg sm:text-xl lg:text-2xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Garantía de por Vida</h4>
              <p className="text-xs sm:text-sm text-gray-600">Acceso permanente a todo el contenido y actualizaciones futuras sin costo adicional</p>
            </div>
            <div className="flex flex-col items-center text-center p-4 sm:p-5 lg:p-6 bg-white rounded-xl sm:rounded-2xl shadow-sm">
              <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-customer-service-2-line text-white text-lg sm:text-xl lg:text-2xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Soporte 24/7</h4>
              <p className="text-xs sm:text-sm text-gray-600">Equipo de soporte disponible para resolver todas tus dudas en cualquier momento</p>
            </div>
            <div className="flex flex-col items-center text-center p-4 sm:p-5 lg:p-6 bg-white rounded-xl sm:rounded-2xl shadow-sm">
              <div className="w-11 h-11 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-refresh-line text-white text-lg sm:text-xl lg:text-2xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">Actualizaciones Gratis</h4>
              <p className="text-xs sm:text-sm text-gray-600">Recibe todas las mejoras y nuevo contenido sin pagar nada extra</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
